import { Flex } from '@components';
import { styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  position: 'relative',
  height: '100%',
  width: '100%',
  overflow: 'hidden',
  flex: '1 0 auto',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(15),
  textAlign: 'center'
}));

export const BackgroundImage = styled('img')(() => ({
  position: 'relative',
  width: '100%',
  objectFit: 'fill',
  zIndex: -1,
}));

export const BackgroundImageContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  height: '100%',
  width: '100%',
  maxWidth: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  boxShadow: `inset 0 0 20px 20px ${theme.palette.common.white}`,
}));

export const ContentContainer = styled(Flex)(({ theme }) => ({
  flex: '1 0 auto',
  height: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(15),
  zIndex: 1,
  padding: '0 20%'
}));

export const IconContainer = styled(Flex)(({ theme }) => ({
  borderRadius: '100%',
  padding: theme.spacing(10),
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
}));
